import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { Input } from "../FormGrid";
import ActionButtons from "../ActionButtons";
import { inputs } from "../../inputs/inputConfigs";
import { downloadFile } from "../../../actions/reportsActions";

export const FormWrapper = styled.div`
  padding: 24px 24px 8px 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const Anchor = styled.a`
  color: #57abff;
  cursor: pointer;
  text-decoration: none;
`;

export const ErrorPanel = styled.div`
  color: #ff1744;
  font-size: 12px;
  white-space: pre-line;
  padding: 0 24px 8px 24px;
  align-self: stretch;
`;

export const TemplateHelperText = ({ rows, fileName, linkText }) => {
  const handleClick = evt => {
    const blob = new Blob([rows.join("\n")], { type: "text/csv" });
    downloadFile(blob, fileName);
    evt.stopPropagation();
  };
  return (
    <span>
      Provide a valid .csv file -{" "}
      <Anchor onClick={handleClick}>{linkText}</Anchor>
    </span>
  );
};

TemplateHelperText.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.string).isRequired,
  fileName: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
};

const BulkUploadForm = ({
  onSubmit,
  loading,
  pluralEntity,
  file,
  helperText,
  errorMessage,
  children,
}) => {
  const [itemsCount, setItemsCount] = useState(0);

  useEffect(() => {
    if (file) {
      const reader = new FileReader();
      reader.onload = ({ target: { result } }) => {
        setItemsCount(result.split("\n").length - 1);
      };
      reader.readAsText(file.file);
    }
  }, [file]);

  return (
    <Fragment>
      <FormWrapper>
        <Input
          input={{
            ...inputs.importFile,
            inputFileProps: {
              ...inputs.importFile.inputFileProps,
              isForm: true,
            },
            helperText,
            useFileWrapper: true,
          }}
        />
        {children}
      </FormWrapper>

      {errorMessage && <ErrorPanel>{errorMessage}</ErrorPanel>}

      <ActionButtons
        onSend={onSubmit}
        sendButtonText={`Save ${itemsCount} ${pluralEntity}`}
        isModal
        disabled={itemsCount === 0}
        loading={loading}
      />
    </Fragment>
  );
};

BulkUploadForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  pluralEntity: PropTypes.string.isRequired,
  helperText: PropTypes.node.isRequired,
  file: PropTypes.shape({}),
  loading: PropTypes.bool,
  errorMessage: PropTypes.string,
  children: PropTypes.node,
};

export default BulkUploadForm;
